import type { OrderStatus } from '../../../types';
import StatusPill from '../../../components/ui/StatusPill';
import { normalizeOrderStatus } from '../services/fulfillmentStage';

const STATUS_STYLES: Record<OrderStatus, { label: string; className: string }> = {
  AWAITING_DEPOSIT: {
    label: 'Awaiting Deposit',
    className: 'bg-blue-50 text-blue-900 border-blue-200',
  },
  CONFIRMED: { label: 'Confirmed', className: 'bg-emerald-50 text-emerald-900 border-emerald-200' },
  MEASURING: { label: 'Measuring', className: 'bg-cyan-50 text-cyan-900 border-cyan-200' },
  IN_PRODUCTION: {
    label: 'In Production',
    className: 'bg-amber-50 text-amber-900 border-amber-200',
  },
  SHIPPED: { label: 'Shipped', className: 'bg-lime-50 text-lime-900 border-lime-200' },
  RECEIVED: { label: 'Received', className: 'bg-teal-50 text-teal-900 border-teal-200' },
  READY_FOR_DELIVERY: {
    label: 'Ready for Delivery',
    className: 'bg-orange-50 text-orange-900 border-orange-200',
  },
  DELIVERED: { label: 'Delivered', className: 'bg-purple-50 text-purple-900 border-purple-200' },
  COMPLETED: { label: 'Completed', className: 'bg-stone-100 text-stone-700 border-stone-300' },
  CANCELLED: { label: 'Cancelled', className: 'bg-red-100 text-red-900 border-red-300' },
  ON_HOLD: { label: 'On Hold', className: 'bg-yellow-50 text-yellow-900 border-yellow-200' },
};

export default function OrderStatusBadge({ status }: { status: OrderStatus }) {
  // Defensive: tolerate a legacy raw value that bypassed the repository
  // read-boundary normalization (so the badge can never crash on undefined).
  const cfg = STATUS_STYLES[status] ?? STATUS_STYLES[normalizeOrderStatus(status)];
  return <StatusPill label={cfg.label} className={cfg.className} />;
}
